import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import AboutSection from "./components/AboutSection";
import AudienceInsights from "./components/AudienceInsights";
import PerformanceMetrics from "./components/PerformanceMetrics";
import ContentShowcase from "./components/ContentShowcase";
import CaseStudies from "./components/CaseStudies";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <HeroSection />
      <TrustBar />
      <AboutSection />
      <AudienceInsights />
      <PerformanceMetrics />
      <ContentShowcase />
      <CaseStudies />
      <Services />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
